import { render, staticRenderFns } from "./ClientCareReport.vue?vue&type=template&id=279f0185"
import script from "./ClientCareReport.vue?vue&type=script&lang=js"
export * from "./ClientCareReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports